<div class="dialog-title">
  <button mat-icon-button aria-label="close dialog" mat-dialog-close style="margin-right: 4px">
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00005 9.36788L2.10005 14.5653C1.91672 14.7598 1.68338 14.857 1.40005 14.857C1.11672 14.857 0.883382 14.7598 0.700048 14.5653C0.516715 14.3708 0.425049 14.1233 0.425049 13.8228C0.425049 13.5223 0.516715 13.2748 0.700048 13.0803L5.60005 7.8829L0.700048 2.68548C0.516715 2.49102 0.425049 2.24352 0.425049 1.94299C0.425049 1.64246 0.516715 1.39497 0.700048 1.2005C0.883382 1.00604 1.11672 0.908813 1.40005 0.908813C1.68338 0.908813 1.91672 1.00604 2.10005 1.2005L7.00005 6.39793L11.9 1.2005C12.0834 1.00604 12.3167 0.908813 12.6 0.908813C12.8834 0.908813 13.1167 1.00604 13.3 1.2005C13.4834 1.39497 13.575 1.64246 13.575 1.94299C13.575 2.24352 13.4834 2.49102 13.3 2.68548L8.40005 7.8829L13.3 13.0803C13.4834 13.2748 13.575 13.5223 13.575 13.8228C13.575 14.1233 13.4834 14.3708 13.3 14.5653C13.1167 14.7598 12.8834 14.857 12.6 14.857C12.3167 14.857 12.0834 14.7598 11.9 14.5653L7.00005 9.36788Z"
        fill="#515251" />
    </svg>
  </button>
</div>
<div style="display:flex; place-content: start; margin-bottom: 23px; ">
  <span
    style="font-family: 'Roboto'; font-style: normal; font-weight: 600; font-size: 22px; line-height: 110%; color: rgba(81, 82, 81, 1); margin-left:18px">GM
    My
    Rewards</span>
</div>
<div *ngIf="dialogData.offers$ | async as offers" style="display:block; place-content: start;">
  <div *ngFor="let offer of offers"
    style="background:rgba(0, 84, 166, 0.1); box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 4px; min-height: 138px; width: 570px !important; margin-bottom: 12px; margin-left: 28px;">
    <div style="margin-left: 27px; margin-bottom: 24px; padding-top: 19px;">
      <span
        style="font-family: 'Roboto'; font-weight: 600; font-size: 16px; color: rgba(81, 82, 81, 1);">{{offer.offerName}}</span>
    </div>
    <div style="margin-left: 27px">
      <span
        style="font-family: 'Roboto'; font-weight: 400; font-size: 16px; color: rgba(81, 82, 81, 1)">{{offer.offerDescription}}</span>
    </div>
  </div>
</div>